import { round_to, unwrap_arr } from './index';

const scale = (num, in_min, in_max, out_min, out_max) => {
  return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
};
// god bless https://hackernoon.com/a-simple-pie-chart-in-svg-dbdd653b6936
const calc_percent = percent => {
  const x = Math.cos(2 * Math.PI * percent);
  const y = Math.sin(2 * Math.PI * percent);
  return [x, y];
};

const calc_min = arr =>
  arr
    .map(x => x.value)
    .reduce((previous, current) => {
      return previous < current ? previous : current;
    });

const calc_max = arr =>
  arr
    .map(x => x.value)
    .reduce((previous, current) => {
      return previous > current ? previous : current;
    });

const calc_total = arr =>
  arr
    .map(x => x.value)
    .reduce((acc, val) => {
      return acc + val;
    }, 0);

const calc_average = (total, l) => round_to(total / l, 0);

const calc_median_point = (l, total, min, max, chart_height, topSpace) => {
  const total_normalized = round_to(scale(total, min, max, 0, chart_height), 0);
  const average_normalized = round_to(total_normalized / l, 0);

  return scale(average_normalized, min, max, 0, chart_height - topSpace);
};

const calc_item_height = (v, min, max, chart_height, topSpace) =>
  round_to(
    scale(
      v,
      min,
      max,
      0,
      v < topSpace ? chart_height : chart_height - topSpace,
    ),
    0,
  );
const calc_item_width = (chart_width, chunk) =>
  round_to(chart_width / chunk, 0);

const calc_color = (shades, i) =>
  Array.isArray(shades)
    ? RGB_Linear_Blend(i / 10, shades[0], shades[1])
    : RGB_Linear_Shade((i * 16) / 100, shades);

const calc_origin = (arr, chunk, chart_height, chart_width, spacing) => {
  const l = arr.length;
  let active;
  if (l > chunk) {
    active = unwrap_arr(chunk(arr, chunk));
  }
  const emptyness = chunk - l;
  let origin = {};
  if (chart_width > 250) {
    if (emptyness % 2 === 0) {
      let drift = emptyness / 2;
      origin = {
        x: drift * spacing,
        y: chart_height,
      };
    } else {
      let drift = -~((chunk - l) / 2);
      origin = {
        x: (drift - 1) * spacing,
        y: chart_height,
      };
    }
  } else {
    origin = {
      x: 0,
      y: chart_height,
    };
  }
  return origin;
};

export const RGB_Linear_Blend = (p, c0, c1) => {
  var i = parseInt,
    r = Math.round,
    P = 1 - p,
    [a, b, c, d] = c0.split(','),
    [e, f, g, h] = c1.split(','),
    x = d || h,
    d = x
      ? ',' +
        (!d
          ? h
          : !h
          ? d
          : r((parseFloat(d) * P + parseFloat(h) * p) * 1000) / 1000 + ')')
      : ')';
  return (
    'rgb' +
    (x ? 'a(' : '(') +
    r(
      i(a[3] == 'a' ? a.slice(5) : a.slice(4)) * P +
        i(e[3] == 'a' ? e.slice(5) : e.slice(4)) * p,
    ) +
    ',' +
    r(i(b) * P + i(f) * p) +
    ',' +
    r(i(c) * P + i(g) * p) +
    d
  );
};

export const RGB_Linear_Shade = (p, c) => {
  var i = parseInt,
    r = Math.round,
    [a, b, c, d] = c.split(','),
    P = p < 0,
    t = P ? 0 : 255 * p,
    P = P ? 1 + p : 1 - p;
  return (
    'rgb' +
    (d ? 'a(' : '(') +
    r(i(a[3] == 'a' ? a.slice(5) : a.slice(4)) * P + t) +
    ',' +
    r(i(b) * P + t) +
    ',' +
    r(i(c) * P + t) +
    (d ? ',' + d : ')')
  );
};

export default {
  calc_average,
  calc_color,
  calc_item_height,
  calc_item_width,
  calc_min,
  calc_max,
  calc_percent,
  calc_total,
  calc_origin,
  calc_median_point,
};
